import React, { useState } from "react";
import { RouterProvider } from "react-router-dom";
import Router from "./Routing";

export const Pass = () => {
  const [pass, setPass] = useState('');

  return (
    <>
      {pass === "secret" ? (
        <>
          <div className="  h-screen">
            <RouterProvider router={Router} />
          </div>
        </>
      ) : (
        <div className="flex h-screen">
          <div className="flex flex-col min-h-[50vh] w-1/2 bg-[#D5CEA3] m-auto text-center rounded-lg shadow-lg">
            <div className="m-auto">
            <p className="pb-8 text-2xl font-semibold text-[#3C2A21]">Enter Access Key: </p>
            <input
              className="p-2 rounded-md"
              type="password"
              value={pass}
              onChange={(e) => setPass(e.target.value)}
            />
            </div>
          </div>
        </div>
      )}
    </>
  );
};
